import {useScrollyTellProps} from "../Admin/scrollytellContext";

export const useSection = sectionId => {
    const {story} = useScrollyTellProps()
    return story.sections[sectionId]
}